<template>
    <transition name="fade">
        <div class="modal" :class="{'show':modal_show}" tabindex="-1" aria-hidden="true" v-if="modal_show">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">HRIS Data Privacy Consent</h5>
                        <button type="button" class="btn btn-round close" @click="close">
                            <i class="mdi mdi-close"></i>
                        </button>
                    </div>
                    <div class="modal-body">
                        In compliance with the Data Privacy Act (DPA) of 2012, and its Implementing Rules and Regulations (IRR) effective since September 8, 2016, I allow Versatech International Inc. and its affiliates to provide me certain services in relation to my employment. As such, I agree and authorize Versatech International Inc to:
                        <br><br>
                        1. Continue to use my personal information to process employment services<br>
                        2. Retain my information for a period of five years from the date of termination of my employment. I agree that my information will be deleted/destroyed after this period.<br>
                        3. Share my information to affiliates and necessary third parties for any legitimate business purpose. I am assured that security systems are employed to protect my information.<br><br>
                        I acknowledge that Versatech International Inc. (VII) and its affiliates recognize their responsibilities under the Republic Act No. 10173 (Act), also known as the Data Privacy Act of 2012, with respect to the data they collect, record, organize, update, use, consolidate or destruct from the employees. The personal data obtained from this portal is entered and stored within the company’s authorized information and communications system and will only be accessed by the VII authorized personnel. VII has instituted appropriate organizational, technical and physical security measures to ensure the protection of the employee’s personal data.
                        <br><br>
                        I also acknowledge and warrant that I have acquired the consent from all parties relevant to this consent and hold free and harmless and indemnify Versatech International Inc. from any complaint, suit, or damages which any party may file or claim in relation to my consent
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn" @click="close">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    data() {
        return {
            modal_show: false
        }
    },
    methods: {
        close() {
            this.modal_show = false;
        }
    },
    mounted() {
        this.$emitter.on('show_terms', () => {
            this.modal_show = true;
        });
    }
}
</script>

<style scoped>
.modal::after {
    background: #000;
    content: '';
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    z-index: -1;
    opacity: 0.5;
}

.modal.show {
    display: block;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>